import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button } from '@mui/material';
import { psiTokens } from '../theme/psiTheme';

export default function CertificateLookupForm({ initialValue = '' }) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (trimmed) navigate(`/verify/${trimmed.toUpperCase()}`);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ display: 'flex', gap: 1.5, flexDirection: { xs: 'column', sm: 'row' } }}
    >
      <TextField
        fullWidth
        placeholder="Record ID, e.g. SN1053"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        size="small"
        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: psiTokens.background.primary, borderRadius: '8px' } }}
      />
      <Button
        type="submit"
        variant="contained"
        sx={{
          background: `linear-gradient(90deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light})`,
          color: '#ffffff',
          fontSize: '12px',
          fontWeight: 700,
          textTransform: 'uppercase',
          px: 3,
          flexShrink: 0,
        }}
      >
        Verify
      </Button>
    </Box>
  );
}
